import React from "react";

const Loading: React.FC = () => {
  return <div></div>;
};

export default Loading;
